import actionType from "./actionType";
import {AssetFilter, State} from "./state";
import {Asset, SearchResult} from "../../interface/Server";

export interface Action {
    type: actionType
    payload: {
        assetGroups?: { [technicalName: string]: Array<Asset> },
        assets?: Array<Asset>
        filter?: AssetFilter
        searchResults?: Array<SearchResult>,
        showDonors?: boolean,
    }

}


const dispatch = (state: State, action: Action): State => {
    switch (action.type) {
        case actionType.ASSETS_INIT_ASSETS: {
            return ({
                ...state,
                assets: action.payload.assets ? action.payload.assets : [],
                assetGroups: action.payload.assetGroups ? action.payload.assetGroups : {},
            })
        }
        case actionType.ASSET_EDIT_FILTER: {
            return (
                {
                    ...state,
                    filter: {
                        ...state.filter,
                        ...action.payload.filter

                    }
                }
            )
        }
        case actionType.ASSET_RESET_FILTER: {
            return (
                {
                    ...state,
                    filter: {
                        price: {
                            min: 0,
                            max: 50000,
                        }
                    }
                }
            )
        }
        case actionType.SEARCH_RESULT_SUCCESSFUL: {
            return (
                {
                    ...state,
                    searchResults: action.payload.searchResults,
                }
            )
        }
        case actionType.CLEAR_SEARCH_RESULTS: {
            return (
                {
                    ...state,
                    searchResults: [],
                }
            )
        }
        case actionType.SET_SHOW_OTHER_DONORS: {
            return (
                {
                    ...state,
                    showDonors: action.payload.showDonors,
                }
            )
        }
        default:
            return state
    }
};


export default dispatch

